import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const Subtract = createSvgIcon(
  <path d="M0 10.875h24v2.25H0v-2.25Z" />,
  'Subtract'
);

export { Subtract };